module.exports = __webpack_public_path__ + "img/deltares-logo.2c1b17f9.png";